<template>
    <div>
        <div id="graph" style="height: 100vh;"></div>
    </div>
</template>
<script>
import { getProjectById } from '@/api/project';
import { listTask } from '@/api/task/task';
import { initGraph, graphRender, numbericWidth, findItem } from './ProjectViewGraphOption';
let graph;

export default {
    data() {
        return {
            dialog: false,
            graphData: {},
        }
    },
    mounted() {
          // 发送消息 data = {type : type, message : message};
        function sendMessageToCSharp(data) {
            if (window.vuplex == null) {
                console.log('window.vuplex == null');
                return;
            }
            window.vuplex.postMessage(data);
        }
        const message = { width: 1920, height: 1080 };
        sendMessageToCSharp({ type: 'init', message: JSON.stringify(message) });
        this.$nextTick(() => {
            this.initData().then(() => this.initGraph())
        })
    },
    methods: {
        async initData() {
            const projectRes = await getProjectById({
                id: this.$route.params.projectId
            });
            const project = projectRes.data;
            const taskRes = await listTask({
                project: project._id,
                perPage: 1000
            })
            const taskList = taskRes.data.rows;
            console.log('project :>> ', project);
            console.log('taskList :>> ', taskList);
            if (Object.keys(project).length === 0) {
                this.graphData = {};
                return;
            };
            if (project.projectGraphData === undefined) {
                let root = {
                    id: project._id,
                    type: 'root',
                    label: project.name ?? '未命名节点',
                    width: numbericWidth(project.name),
                    height: 50,
                    appendData: project,
                };

                root.children = taskList.map(task => {
                    let data = {
                        id: task._id,
                        type: 'task',
                        label: task.name,
                        width: numbericWidth(task.name),
                        height: 50,
                        children: [],
                        appendData: task,
                    };
                    return data;
                })

                this.graphData = root;
                return;
            }
            this.graphData = project.projectGraphData
        },
        initGraph() {
            let dom = document.getElementById('graph');
            graph = initGraph(dom);
            this.render()

            graph.on('node:click', (e) => {
                let { node } = e;
                let data = findItem(this.graphData, node.id)
                if (data.node.type === 'task') {
                    if (!window.vuplex) return;
                    window.vuplex.postMessage({
                        type: "home",
                        message: JSON.stringify({
                            taskId: data.node.appendData._id,
                            taskName: data.node.appendData.name,
                        })
                    });
                }
            })
        },
        render() {
            graphRender(this.graphData, graph);
        },
    }
}
</script>
<style>
.topic-image {
    visibility: hidden;
    cursor: pointer;
}

.x6-node:hover .topic-image {
    visibility: visible;
}

.x6-node-selected rect {
    stroke-width: 2px;
}
</style>